<template>
  <div class="body-set-password">
    <b-row class="justify-content-md-center">
      <b-col cols="12" class="text-center">
        <img :src="logoUrl" alt="sbo-logo" style="height: 100px" class="my-3" />
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col cols="12" lg="4" md="8">
        <b-card class="m-2" no-body>
          <div class="m-2">
            <div class="mb-2 mt-1 text-center">
              <h2>{{ $t('messages.greetings.change_password', {name: `${user.name} ${user.last_name}`}) }}</h2>
              <br/>
              <span>
                {{ $t('users.set_password.password_rules') }}
              </span>
            </div>
            <div style="margin: auto">
              <div>
                <b-form-group
                  :label="$t('users.set_password.password')"
                  label-for="password"
                  class="text-capitalize"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="password"
                    vid="password"
                    rules="required|min:8|password"
                  >
                    <b-form-input
                      id="password"
                      type="password"
                      class="d-inline-block mr-1 text-capitalize"
                      :placeholder="$t('users.set_password.password')"
                      v-model="newPassword"
                    />
                    <small class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="mt-2 mb-3">
                <b-form-group
                  :label="$t('users.set_password.password_retype')"
                  label-for="password_retype"
                  class="text-capitalize"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="password_retype"
                    vid="password_retype"
                    rules="required|confirmed:password|min:8|password"
                  >
                    <b-form-input
                      id="password_retype"
                      class="d-inline-block mr-1 text-capitalize"
                      type="password"
                      :placeholder="$t('users.set_password.password_retype')"
                      v-model="retypePassword"
                    />
                    <small class="text-danger">
                      {{ errors[0] }}
                    </small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="mt-3">
                <b-button
                  variant="secondary"
                  style="float: right"
                  :disabled="(newPassword == '' || retypePassword == '') || disabledButton"
                  @click="changePassword()"
                >
                  <span class="text-nowrap text-capitalize">{{
                    $t("actions.save")
                  }}</span>
                </b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, confirmed, min, password } from "@validations";
import axios from "axios";
import router from "@/router";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BImg,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  setup() {
    const newPassword = ref("");
    const retypePassword = ref("");
    const disabledButton = ref(false)
    const toast = useToast();
    const user = ref({});

    const { t } = useI18nUtils();

    const trans = {
      "messages.redirect.login": t(
        "messages.redirect.login"
      ),
    };

    const token = router.currentRoute.params.token;
    const url = `${window.__env.VUE_APP_BASE_URL}/v1/users/data`;

    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data: resp }) => {
        user.value = resp.data;
      })
      .catch(response => {
        if (response.response.status == 401) {
          router.push({ name: "auth-login" });
        }
      })

    const changePassword = () => {
      const req = {
        password: newPassword.value,
        password_confirmation: retypePassword.value
      };

      const urlPassword = `${window.__env.VUE_APP_BASE_URL}/v1/user/setPassword`;

      axios
        .put(urlPassword, req, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(({ data: resp }) => {
          toast({
            component: ToastificationContent,
            props: {
              title: resp.message,
              text: trans['messages.redirect.login'],
              icon: 'CheckIcon',
              variant: 'success',
            },
          })

          disabledButton.value = true;

          setTimeout(() => {
            router.push({ name: "auth-login" });
          }, 5000)
        })
    }

    return {
      newPassword,
      retypePassword,
      logoUrl: require("@/assets/images/sbo_logo.png"),
      changePassword,
      user,
      disabledButton
    };
  },
};
</script>

<style scoped>
.body-set-password {
  background-color: #1b3d5e !important;
  height: 100vh;
}

.card-margin {
  transform: translate(-50%, 50%);
  left: 50%;
  margin: auto !important;
}
</style>